import { Suspense, type ReactNode } from "react";
import { BrandingStyleInjectorLazy as LazyBrandingStyleInjector } from "@/lib/prerenderedAppChunks";

/**
 * DashboardProviders — wraps dashboard/app routes with providers and
 * side-effect components that have no marketing dependency.
 *
 * Phase 1 scope:
 *   - BrandingStyleInjector (only consumer of `brandingConfig` from
 *     PlatformSettingsContext; no marketing route reads tenant branding).
 *
 * SessionProvider / PlatformSettingsProvider / Toaster / Sonner stay in
 * App.tsx because marketing surfaces (Header, PersonaContext, Footer
 * newsletter form, Contact/Demo/Waitlist forms, charge-rate calculator)
 * still depend on them. Their removal from marketing is Phase 2 work.
 */
export function DashboardProviders({ children }: { children: ReactNode }) {
  return (
    <>
      <Suspense fallback={null}>
        <LazyBrandingStyleInjector />
      </Suspense>
      {children}
    </>
  );
}